import image1 from "../assets/t-image1.png";
import image2 from "../assets/t-image2.jpg";
import image3 from "../assets/t-image3.jpg";

export const testimonialsData = [
  {
    image: image1,
    review:
      "Zumba classes here are pure joy! The energy, music, and amazing women make it feel like family. I actually look forward to working out every single day!",
    name: 'Shreya',
    status : 'HOUSE MAKER'
  },
  {
    image: image2,
    review: 'After months of consistent aerobics, I’ve lost inches, gained strength, and feel unstoppable. This gym helped me transform not just my body, but my confidence too!',
    name: 'Divya Reddy',
    status: 'STUDENT'
  },
  {
    image : image3,
    review:'I love how this gym caters exclusively to women—it’s so refreshing! The workouts are tailored to our needs, and the positive, judgment-free atmosphere keeps me coming back. Highly recommend!',
    name: 'Ritika Gowda',
    status: "BUISNESS OWNER"
  }
];
